import { render, staticRenderFns } from "./EventFlowLocationName.vue?vue&type=template&id=a10c6a1c&scoped=true"
import script from "./EventFlowLocationName.vue?vue&type=script&lang=ts"
export * from "./EventFlowLocationName.vue?vue&type=script&lang=ts"
import style0 from "./EventFlowLocationName.vue?vue&type=style&index=0&id=a10c6a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10c6a1c",
  null
  
)

export default component.exports